<template>
	<div class="top-div">
		<div class="top-div-body">
			<div class="top-div-left">
				<img class="web-logo" width="100px" src="../../assets/img/Header/zqpjlogo.png" />
				<img class="app-logo" src="../../assets/img/Header/applogo.jpg" />
				<p>开封市政泉艺术品鉴定有限公司</p>
			</div>
			<div class="top-div-left-app">
			</div>
			<div class="top-div-right">

				<div class="sousuo">
					<el-input placeholder="请输入证书编号" class="input-with-select" size="large" v-model="ratingVal1">
						<template #append>
							<el-button @click="goReting()">查询</el-button>
						</template>
					</el-input>
				</div>

				<div class="div-right-h2">
					<h2>客服热线：0378-178 3784 4475</h2>
				</div>

			</div>

		</div>
		<div class="sousuo-bottom">
			<el-input placeholder="请输入评级编号" class="input-with-select" size="large" v-model="ratingVal1">
				<template #append>
					<el-button @click="goReting()">查询</el-button>
				</template>
			</el-input>
		</div>
	</div>
	<div class="tabs">
		<ul class="istest">
			<router-link style="text-decoration: none" to="/">
				<li><a>网 站 首 页</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/Appreciation">
				<li><a href="#">钱 币 赏 析</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/Standard">
				<li><a href="#">评 级 标 准</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/News/0">
				<li><a href="#">新 闻 公 告</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/Agent">
				<li><a href="#">公 司 代 理</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/About">
				<li><a href="#">关 于 我 们</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/Charge">
				<li><a href="#">收 费 标 准</a></li>
			</router-link>
			<router-link style="text-decoration: none" to="/Contact">
				<li><a href="#">联 系 我 们</a></li>
			</router-link>
		</ul>

		<div class="icon-div" @click.stop="isshow = !isshow">
			<el-icon class="icon-right">
				<Fold />
			</el-icon>
		</div>
		<transition name="vertivcal-menu">
			<ul v-show="isshow" @click.stop="isshow = !isshow" class="istest1">
				<router-link style="text-decoration: none" to="/">
					<li><a>网 站 首 页</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/Appreciation">
					<li><a href="#">钱 币 赏 析</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/Standard">
					<li><a href="#">评 级 标 准</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/News/0">
					<li><a href="#">新 闻 公 告</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/Agent">
					<li><a href="#">公 司 代 理</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/About">
					<li><a href="#">关 于 我 们</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/Charge">
					<li><a href="#">收 费 标 准</a></li>
				</router-link>
				<router-link style="text-decoration: none" to="/Contact">
					<li><a href="#">联 系 我 们</a></li>
				</router-link>
			</ul>
		</transition>
	</div>
</template>

<script>
	import {
		Fold
	} from '@element-plus/icons'
	export default {
		name: 'Footer',
		data() {
			return {
				// 初始时隐藏
				isshow: false,
				//查询鉴定
				ratingVal1: ''
			}
		},
		components: {
			Fold
		},
		methods: {
			//查询鉴定
			goReting() {
				let params = this.ratingVal1.trim()
				if (params != '') {
					this.$router.push({
						path: '/Reting/' + params
					})
				} else {
					this.$notify({
						title: '温馨提示',
						message: '您还未输入证书编号!',
						type: 'warning'
					});
				}

			}
		},
		mounted() {
			this.ratingVal1 = ''
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.top-div {
		background: url("../../assets/img/Header/Heder-backgorund.png") 0px 53%;

		.top-div-body {
			width: 70%;
			height: 100px;
			margin: 0 auto;
			display: flex;

			@media only screen and (max-width: 1216px) {
				width: 100%;
			}
		}

		.top-div-left {
			display: flex;
			width: 60%;

			@media only screen and (max-width: 1100px) {
				font-size: 14px;
			}

			@media only screen and (max-width: 850px) {
				width: 100%;
			}

			@media only screen and (max-width: 470px) {
				width: 100%;
				font-size: 12px;
			}


			p {
				//color: #E22434;
				color: #644b4b;
				margin-left: 30px;
				margin-top: 30px;
				font-size: 30px;
				font-weight: 1000;
				font-family: "楷体", "楷体_GB2312";
				letter-spacing: 100;
				
				@media only screen and (max-width: 850px) {
					display: none;
				}

				@media only screen and (max-width: 470px) {
					margin-left: 10px;
					font-size: 14px;
					margin-top: 40px;
					text-align: center;
					display: none;
				}

				@media only screen and (max-width: 400px) {
					margin-left: 10px;
					margin-top: 40px;
					display: none;
				}

				@media only screen and (max-width: 380px) {
					margin-right: 0px;
					display: none;
				}
			}

			.app-logo {
				width: 100%;
				@media only screen and (min-width:851px) {
					display: none;
				}
				@media only screen and (min-width:850px) {
					width: 100%;
				}
				// @media only screen and (min-width: 750px) {
				// 	display: none;
				// }
				// @media only screen and (min-width: 450px) {
				// 	display: none;
				// }
			}
			.web-logo {
				width: 200px;

				@media only screen and (max-width: 1100px) {
					width: 100%;
					height: 80px;
					margin-top: 10px;
					margin-left: 10px;
				}
				@media only screen and (max-width: 1025px) {
					display: none;
				}
				@media only screen and (max-width: 850px) {
					// width: 160px;
					// height: 60px;
					// margin-top: 20px;
					display: none;
				}
				@media only screen and (max-width: 600px) {
					// width: 160px;
					// height: 60px;
					// margin-top: 20px;
					display: none;
				}

				// @media only screen and (max-width: 450px) {
				// 	// width: 160px;
				// 	// height: 60px;
				// 	// margin-top: 20px;
				// 	display: none;
				// }
			}
			
		}

		.top-div-right {
			width: 40%;
			display: flex;

			@media only screen and (max-width: 1054px) {
				display: block;
			}

			@media only screen and (max-width: 1120px) {
				font-size: 14px;
			}
			@media only screen and (max-width: 850px) {
				display: none;
			}

			@media only screen and (max-width: 600px) {
				display: none;
			}

			.sousuo {
				margin-right: 20px;
				padding-top: 30px;

				@media only screen and (max-width: 1054px) {
					display: none;
				}
			}

			.div-right-h2 {
				h2 {
					text-decoration: underline;
					color: #E22434;
					margin-top: 30px;
					margin-right: -30rem;
					font-style: oblique;
					font-size: 25px;
				}
				@media only screen and (max-width: 1300px) {
					display: none;
				}
			}
		}
	}

	//头部底层的搜索框
	.sousuo-bottom {
		padding: 0 20px;
		display: none;
		margin-bottom: 10px;

		@media only screen and (max-width: 1054px) {
			display: block;
		}
	}

	.tabs {
		background-color: #E22434;

		//background-color: #409EFF;
		//background-color: #409EFF;
		//background-color: #0077F2;
		//background: url(../../assets/img/bc.png);
		//background: rgba(102, 177, 255);
		.istest1 {
			display: none;
		}

		.icon-div {
			display: none;
		}

		@media only screen and (max-width: 1100px) {
			min-height: 55px;
			overflow: hidden;

			.istest {
				display: none;
			}

			.icon-div {
				display: block;
			}

			.icon-right {
				font-size: 30px;
				color: rgb(226, 211, 211);
				float: right;
				margin-right: 8%;
				margin-top: 15px;
				cursor: pointer;
			}

			.istest1 {
				position: absolute;
				display: block;
				margin-top: 60px;
				top: 96px;
				z-index: 3;
				width: 100%;
				background: #F3F3F3;

				@media only screen and (max-width: 1054px) {
					margin-top: 109px;
				}

				li {
					width: 100%;
					margin: 0;
				}
			}
		}

		@media only screen and (max-width: 600px) {
			min-height: 55px;

			.icon-right {
				font-size: 25px;
				margin-top: 13px;
			}
		}

	}

	ul {
		display: flex;
		justify-content: center;

		li {
			list-style: none;
			width: 140px;

			:before {
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 2px;
				background: #69030b;
				transform: scaleX(0);
				transform-origin: 50%;
				transition: .5s;

			}

			:hover:before {
				transform: scaleX(1);
			}

			:hover {
				background: #C71625;
			}

			&:nth-child(1) {
				margin-left: 4%;

				@media only screen and (max-width: 1150px) {
					color: #333333;
				}
			}

			a {
				position: relative;
				display: block;
				padding: 20px 25px;
				text-align: center;
				font-size: 16px;
				color: #FFF;
				text-transform: uppercase;
				text-decoration: none;
				transition: .5s;

				@media only screen and (max-width: 1100px) {
					color: #333333;
				}

				@media only screen and (max-width: 600px) {
					padding: 12px 20px;
					font-size: 15px;
				}
			}
		}
	}
</style>
